'use strict';

$('.o-file').each( function() {
    let $input	 = $(this),
        $label	 = $input.next('label'),
        labelVal = $label.html(),
        configureCancel,
        isImageType;

    // Handle image uploads and display preview
    $input.on('change', function(e) {

        // Display an image if we are in a compatable browser, and the file uploaded is an image
        if(window.FileReader && isImageType(this.files[0])) {

            let reader = new FileReader(),
                previewUrl = '';

            reader.onload = function (e) {
                previewUrl = e.target.result;

                if( previewUrl ) {
                    $label.find('.o-file__preview').removeClass('is-hidden').attr('src', previewUrl);
                    $label.find('.o-file__details').html('');
                    configureCancel($label);
                } else {
                    $label.html( labelVal );
                }
            };

            reader.readAsDataURL(this.files[0]);
        } else {

            // The browser doesn't support the FileReader Object, or we did not get an image,
            // so read the filename and display that instead
            let fileName = '';

            if(this.files && this.files.length > 1) {
                fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
            } else if(e.target.value) {
                fileName = e.target.value.split('\\').pop();
            }

            if (fileName) {
                $label.find('.o-file__details').html(fileName);
                $label.find('.o-file__preview').addClass('is-hidden').attr('src', '');
                configureCancel($label);
            } else {
                $label.html(labelVal);
            }
        }
    });

    // Clear preview on cancel
    configureCancel = function($label) {
        let $cancelButton = $label.find('.o-file__cancel');

        $cancelButton.removeClass('is-hidden');

        $cancelButton.on('click touch', function (e) {
            let $that = $(this),
                $inputToClear = $that.parent().siblings('.o-file');

            e.preventDefault();

            // Clear button and preview info
            $that.addClass('is-hidden');
            $that.siblings('.o-file__preview').addClass('is-hidden').attr('src', '');
            $that.siblings('.o-file__details').html('');

            // Clear the input so that if we submit, this has no value
            $inputToClear.val('');
        });
    };

    // Returns true if given file mime type is an image
    isImageType = function(file) {
        let mimeType;

        if (file === undefined) {
            return false;
        }

        mimeType = file['type'];

        return mimeType.split('/')[0] === 'image';
    };

    // Firefox bug fix for where it ignores the focus expression, we add this state using JS
    $input
        .on('focus', function(){
            $input.addClass('has-focus');
        })
        .on('blur', function(){
            $input.removeClass('has-focus');
        });
});



// WEBPACK FOOTER //
// ./src/js/components/form-upload.js